import { useParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'

import { IStorageService, RouteType } from '@/services/contracts/storage'

type UploadProps = {
  storageService: IStorageService
}

export function useUploadLogo({ storageService }: UploadProps) {
  const { id: institution_id } = useParams()

  const mutation = useMutation({
    mutationKey: ['upload_logo', institution_id],
    mutationFn: ({ file, route }: { file: File; route: RouteType }) =>
      storageService.uploadLogo({ institution_id, route, file }),
  })

  return {
    uploadLogo: mutation.mutateAsync,
    isUploading: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  }
}
